import Http from "./http";

export const getAiCampaignDetailsAPI = (payload) => {
  return Http.post("admin/campaign/get", payload);
};
